import Phaser from 'phaser';
import { Enemy } from './Enemy';
import type { EnemyConfig } from './Enemy';

export class MenacingCoffee extends Enemy {
  private steamTime: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    const config: EnemyConfig = {
      texture: 'menacingCoffee',
      points: 30,
      health: 2, // Tank - takes 2 hits
      fireRate: 2500, // Slower but more dangerous
      projectileSpeed: 180, // Slower but accurate
      projectileTexture: 'coffeeProjectile',
    };

    super(scene, x, y, config);
    
    // Set hitbox size (taller)
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setSize(24, 32);
    
    // Random starting phase
    this.steamTime = Math.random() * Math.PI * 2;
  }

  update(_time: number, delta: number): void {
    // Gentle steam wobble
    this.steamTime += delta * 0.002;
    this.scaleY = 1 + Math.sin(this.steamTime) * 0.02;
  }
}






